<template >
  <div>
    <slot></slot>
    <div class="words-list" v-if="words.length">
      <span>{{ prefix }}</span>
      <el-button @click="onWordAdd(word)" type="text" v-for="(word, index) in words" :key="index">+{{ word }}</el-button>
    </div>
  </div>
</template>
<script>
const stop = (event) => {
  event.stopPropagation()
  event.preventDefault()
}

let inputEl = null
export default {
  props: {
    words: {
      type: Array,
      default: () => []
    },
    value: {
      type: String
    },
    title: {
      type: String
    },
    el: {
      type: HTMLInputElement
    },
    regExp: {
      type: RegExp,
      default: () => new RegExp('{(.*?)}', 'g')
    }
  },
  data() {
    return {}
  },
  beforeDestroy() {
    this.destroyEventListeners()
  },
  mounted() {
    this.initEventListeners()
  },
  computed: {
    prefix() {
      return typeof this.title === 'string' ? this.title : '插入动态名称：'
    }
  },

  methods: {
    destroyEventListeners() {
      if (inputEl) {
        inputEl.removeEventListener('keydown', this.onInputKeydown)
        inputEl.removeEventListener('mouseup', this.onInputMouseup)
        inputEl.removeEventListener('paste', this.onPaste)
      }
    },
    initEventListeners() {
      this.destroyEventListeners()

      const [input] = this.$slots.default || []

      if (input) {
        inputEl = input.elm.querySelector('input')
      }

      if (this.el) {
        inputEl = this.el
      }

      if (!inputEl) return

      inputEl.addEventListener('keydown', this.onInputKeydown)
      inputEl.addEventListener('mouseup', this.onInputMouseup)
      inputEl.addEventListener('paste', this.onPaste)
    },
    onWordAdd(word) {
      this.initEventListeners()

      if (!inputEl) return this.$Message.warning('请先确定插入动态词位置')
      word = `{${word}}`
      if (!inputEl.value.includes(word)) {
        inputEl.setRangeText(word, inputEl.selectionStart, inputEl.selectionEnd, 'end')
        inputEl.focus()
        this.$emit('input', inputEl.value)
      } else {
        this.$Message.warning('动态词已存在')
      }
    },

    onPaste(event) {
      const text = event.clipboardData.getData('text/plain')
      const textGroup = text.match(this.regExp) || []
      if (textGroup.length > 0) {
        event.preventDefault()
        this.$Message.warning('不支持粘贴包含动态词的内容')
        document.execCommand('insertText', false, text.replace(this.regExp, ''))
        this.$emit('input', this.value)
      }
    },

    onInputMouseup(event) {
      this.onInputKeydown(event)
    },

    onInputKeydown(event) {
      const { target } = event
      const startIndex = target.selectionStart

      // 匹配字符串中全部的动态词组
      const dynamicGroups = inputEl.value.match(this.regExp) || []
      // 计算匹配到的动态词在整个字符串中的长度范围
      const groupRanges = dynamicGroups.map((word) => {
        const start = inputEl.value.indexOf(word)
        const end = start + word.length
        return [start, end]
      })

      // 如果删除的startIndex进入到动态词范围，将整个动态词清除
      for (const i in groupRanges) {
        const [start, end] = groupRanges[i]

        const initStr = dynamicGroups[i]

        if (startIndex >= start && startIndex <= end) {
          if (event.key === 'Backspace' || event.key === 'Delete') {
            inputEl.value = inputEl.value.replace(initStr, '')
            this.$nextTick(() => {
              this.$emit('input', inputEl.value)
              inputEl.selectionStart = inputEl.selectionEnd = start
            })

            stop(event)
            break
          }

          if (event.key === 'ArrowLeft') {
            inputEl.selectionStart = inputEl.selectionEnd = start
          }

          if (event.key === 'ArrowRight') {
            inputEl.selectionStart = inputEl.selectionEnd = end
          }
        }

        // 点击动态词中间时，把光标移出来
        if (startIndex > start && startIndex < end) {
          if (event.type === 'mouseup') {
            inputEl.selectionStart = inputEl.selectionEnd = end
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.words-list {
  font-size: 12px;
}
</style>
